import { useNotify } from 'react-admin';

import { useChangeDownloadedStatus } from './useChangeDownloadedStatus';
import { useChangeViewedStatus } from './useChangeViewedStatus';

type Props = {
  onSuccess?: () => void;
};

type ReturnValue = {
  markNotificationDownloaded: (id: string) => void;
};

export function useMarkNotificationDownloaded({ onSuccess }: Props): ReturnValue {
  const notify = useNotify();
  const { changeViewedStatus } = useChangeViewedStatus({
    onError: (error) => {
      notify(error.data?.errors[0]?.title, { type: 'error' });
    },
  });
  const { changeDownloadedStatus } = useChangeDownloadedStatus({
    onSuccess,
    onError: (error) => {
      notify(error.data?.errors[0]?.title, { type: 'error' });
    },
  });

  const markNotificationDownloaded = (id: string) => {
    changeViewedStatus([id]);
    changeDownloadedStatus(id);
  };

  return { markNotificationDownloaded };
}
